module.exports = {"name":"hbbtvhtml5","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-05-09","repo":"https://bitbucket.org/npaw/hbbtvhtml5-adapter-js","libVersion":"6.2.4","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0